import { FC } from 'react';
import { MdOutlineEdit } from 'react-icons/md';
import { MdAISparkles } from '@icons';
import Button from '@srm/ui/button';
import { SearchMode } from '@models/search/search.types';

export interface ISearchQueryHeaderProps {
    text: string;
    mode: SearchMode;
    onEditQuery: () => void;
}

/**
 * Запрос — заголовок страницы. «Глобальный поиск» уходит в надзаголовок: пользователь
 * и так знает, где он, а важно то, что именно он искал.
 */
const SearchQueryHeader: FC<ISearchQueryHeaderProps> = ({ text, mode, onEditQuery }) => (
    <header className="gsearch__head">
        <div className="gsearch__head-main">
            <div className="gsearch__eyebrow">
                Глобальный поиск
                {mode === 'ai' && (
                    <span className="gsearch__ai-badge">
                        <MdAISparkles size={12} aria-hidden="true" />
                        AI
                    </span>
                )}
            </div>
            <h1 className="gsearch__query" title={text}>
                {text || 'Поиск по фильтрам'}
            </h1>
        </div>
        <Button
            variant="outline-thin"
            size="sm"
            onClick={onEditQuery}
            startAdornment={<MdOutlineEdit size={16} aria-hidden="true" />}
        >
            Изменить запрос
        </Button>
    </header>
);

export default SearchQueryHeader;
